import { H4, Text } from '@payaca/ambrosia';
import { FC } from 'react';

export type SuggestedEquipmentItem = {
  label: string;
  name: string;
  detail?: string;
};

type SuggestedEquipmentProps = {
  items: SuggestedEquipmentItem[];
  title?: string;
};

/** A deliberately compact summary; detailed product selection belongs in Glow/Flow. */
const SuggestedEquipment: FC<SuggestedEquipmentProps> = (props) => {
  const { items, title = 'Suggested equipment' } = props;
  const visibleItems = items.filter((item) => item.name);
  if (!visibleItems.length) return null;

  return (
    <div className="border-t border-gray-200 pt-4">
      <div className="mb-2">
        <H4>{title}</H4>
      </div>
      {/* oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Auto-fill grid, so the column count follows the card width */}
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,220px),1fr))] gap-x-6 gap-y-2">
        {visibleItems.map((item) => (
          <div className="min-w-0" key={item.label}>
            <Text level="supporting">{item.label}</Text>
            <div className="break-words">
              <Text as="span">{item.name}</Text>
            </div>
            {item.detail && <Text level="supporting">{item.detail}</Text>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuggestedEquipment;
